module.exports = {
  type: 'hex-g2',
  group: 'chart',
  name: 'g2',
  isForm: false,
  props: {
    listdata: {
      name: '图表数据',
      type: 'param-group',
      default: [
        {
          group: "London",
          name: "Jan.",
          val: 18.9
        },
        {
          group: "London",
          name: "Feb.",
          val: 28.8
        },
        {
          group: "Berlin",
          name: "Jan.",
          val: 12.4
        },
        {
          group: "Berlin",
          name: "Feb.",
          val: 23.2
        }
      ],
      allowed: true
    },
    mockData: {
      name: '随机数据',
      type: 'hidden',
      default: '',
      allowed: true
    },
    name: {
      name: '名称字段',
      default: 'name'
    },
    value: {
      name: '数值字段',
      default: 'val'
    },
    group: {
      name: '分组字段',
      default: 'group'
    },
    title: {
      name: '标题',
      default: '标题'
    }
  },
  style: {},
  // 新的events 用来处理编译用
  interfaces: {
  },

  // events 保证原来不报错
  events: {}
}



// WEBPACK FOOTER //
// ./packages/components/g2/src/define.js